import React from "react";
import { NavLink } from "react-router-dom";
import styles from "../styles";
import { Typography, useMediaQuery, useTheme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

const Navigation = (props) => {
  const { classes } = props;
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div
      className={classes.navigationBar}
      style={matchesSM ? { marginLeft: "1em" } : null}
    >
      <span>
        <NavLink to="/">
          <Button
            style={{
              color: "black",
              fontWeight: "bold",
              textTransform: "capitalize",
            }}
          >
            <Typography
              variant={matchesSM ? "body1" : "h6"}
              style={{
                color: "black",
                fontWeight: "bold",
                textTransform: "capitalize",
              }}
            >
              Home
            </Typography>
          </Button>
        </NavLink>
      </span>

      <span>
        <NavLink to="/about">
          <Button style={{ color: "black", fontWeight: "bold" }}>
            <Typography
              variant={matchesSM ? "body1" : "h6"}
              style={{
                color: "black",
                fontWeight: "bold",
                textTransform: "capitalize",
              }}
            >
              About
            </Typography>
          </Button>
        </NavLink>
      </span>
    </div>
  );
};

//export default Navigation;
export default withStyles(styles)(Navigation);
